export const state = {
  settings: {},
  dates: [],
};
